import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'
import fonts from '../styles/fonts';
import { StyleSheet, css } from '../utility/paypalAphrodite';

const STYLES = StyleSheet.create({
	payPalStyles: {
		fontFamily: fonts.ppSansBigRegular
	},
	wrapper: {
		marginTop: 30,
		marginBottom: 22,
	},
	havePPLabel: {
		marginRight: 5,
		fontSize: 15,
		fontFamily: fonts.ppSansBigRegular
	},
	logInBtn: {
		fontSize: 13,
		paddingTop: 5,
		marginBottom: 0,
		fontFamily: fonts.ppSansBigMedium
	}
});

class PayPalLogIn extends React.Component {
	constructor() {
		super();
	}

	render () {
		const guestMessages = localsMessages('common/pPLogIn') || {}
		const havePPLabel = guestMessages.label && guestMessages.label.havePP || ''
		const logInLabel = guestMessages.label && guestMessages.label.logIn || ''

		return (
			<div className={`row text-center ${css(STYLES.wrapper)}`}>
				<span className={css(STYLES.havePPLabel)}>{havePPLabel}</span>
				<a id="payWithPP"
					className={`vx_btn vx_btn-primary vx_btn-small ${css(STYLES.logInBtn)}`}
					onClick={this.props.handleLogIn}>{logInLabel}</a>
			</div>
		);
	}
}

PayPalLogIn.propTypes = {
	label: PropTypes.string,
	handleLogIn: PropTypes.func
};

export default PayPalLogIn



// WEBPACK FOOTER //
// ./components/guestPPLogIn.js